import { CoreGlobalFooter } from '@care/navigation';
import { Grid } from '@mui/material';
import { Error404 } from '@care/react-pages';
import SeoGlobalNavbar from '@/components/SeoGlobalNavbar';

export default function Custom404() {
  return (
    <Grid container>
      <Grid item xs={12}>
        <SeoGlobalNavbar enrollmentURL="/enroll-care-seeker-p1042-q111082615.html" />
      </Grid>
      <Grid item xs={12} py={3} px={9}>
        <Error404 prev="/" />;
      </Grid>
      <Grid item xs={12}>
        <CoreGlobalFooter />
      </Grid>
    </Grid>
  );
}
